import React, { Component } from "react";
import Waitable from '../../components/Waitable';
import PropTypes from "prop-types";
import Slider from 'rc-slider';
import Handle from '../../components/Handle';
import BigCalendar from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from 'moment';

// React DateRangePicker
import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import './react_dates_overrides.css';


import {
  Badge,
  Button,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
} from 'reactstrap';


import { DateTimePicker } from 'react-widgets'


import momentLocalizer from 'react-widgets-moment';
import { encode } from "punycode";


moment.locale('en');
momentLocalizer();


BigCalendar.setLocalizer(
  BigCalendar.momentLocalizer(moment)
);


export default class Capacity extends Component {
  constructor(props) {
    super(props);

    //let capacityArray = props.capacity.toArray();
    //capacityArray = capacityArray.filter(cap => typeof (cap) !== "boolean");
    //let values = {};

    //capacityArray.forEach(obj => {
    //obj = obj.toObject();
    //values[obj.terminal] = obj.avg
    //});

    this.state = {
      date: this.props.initialDate,
      value: ['UT', 'OH'],
      windowWidth: window.innerWidth,
      orientation: 'horizontal',
      openDirection: 'down',
      //...values

    };

    
    this.onFocusChange = this.onFocusChange.bind(this);
    this.myOnSliderChange = this.myOnSliderChange.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
  }

  onFocusChange({ focused }) {
    this.setState({ focused });
  } 
  myOnSliderChange(terminal, v) {
    let state = {};
    state[terminal] = v;
    this.setState(state);
    this.props.onSliderChange(terminal, v)
  }

  onDateChange(date){

    let capacityArray = this.props.capacity.toArray();
    capacityArray = capacityArray.filter(cap => typeof (cap) !== "boolean");
    let values = {};

    capacityArray.forEach(obj => {
    obj = obj.toObject();
    values[obj.terminal] = ""
    });
    this.setState({      
      ...values
    });
    this.props.onDateChange(date);
    /*
    let capacityArray = nextProps.capacity.toArray();
    capacityArray = capacityArray.filter(cap => typeof (cap) !== "boolean");
    let values = {};

    capacityArray.forEach(obj => {
    obj = obj.toObject();
    values[obj.terminal] = obj.avg
    });

    this.setState({      
      ...values
    });
    */
  }

  
  render() {
    const { capacity, onSliderChange, date, onDateChange, submit } = this.props;
    const { focused, values } = this.state;
    const { myOnSliderChange } = this;

    let capacityArray = capacity.toArray();
    capacityArray = capacityArray.filter(cap => typeof (cap) !== "boolean");
    let capacityGrid = capacityArray.map(obj => {
      obj = obj.toObject();
      return (
        <Row key={obj.terminal} >
          <Col className="pt-3">
            <Badge color="danger"> {obj.avg} </Badge> {"  "}
            <Badge> { this.state[obj.terminal] } </Badge> {"  "}     
            {obj.terminal} {" "}
            <Slider color="green" onAfterChange={(v) => {
              myOnSliderChange(obj.terminal, v);
            }}
              min={0}
              max={100}
              defaultValue={obj.avg}
              handle={Handle} />
                      
          </Col>
        </Row>
      );
    });


    return <div className="animated fadeIn">
      <Row>
        <Col xs="12" md="6">
          <Card>
            <CardHeader>
              <i className="fa fa-bar-chart"></i> Capacity Adjustments
            </CardHeader>
            <CardBody>
              <Row>
                <Col md="6">

                  <DateTimePicker
                    //value={moment(this.state.startDate).toDate()}
                    defaultValue={new Date()}
                    min={new Date()}
                    time={false}
                    onChange={ this.onDateChange }
                  />

                </Col>
              </Row>
              <Row className="pt-3">
                <Col>
                  <Waitable entities={[capacity]}>
                    {capacityGrid}
                    <hr />
                    <Button onClick={submit} color="primary" className="px-4">Update</Button>
                  </Waitable>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>;

  }
}
Capacity.propType = {
  capacity: PropTypes.array
};



// WEBPACK FOOTER //
// ./src/views/Capacity/Capacity.js